// src/firebaseAuth.js
import { getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword } from "firebase/auth";
import { firebaseConfig } from './firebaseConfig'; // Ahora firebaseConfig se importa correctamente
import { initializeApp } from 'firebase/app';

const app = initializeApp(firebaseConfig); // Ya que firebaseConfig está correctamente exportado
const auth = getAuth(app);

// Función para iniciar sesión
export const login = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return userCredential.user;
  } catch (error) {
    throw error;
  }
};

// Función para registrar un nuevo usuario
export const register = async (email, password) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    return userCredential.user;
  } catch (error) {
    throw error;
  }
};
